<template>
  <div class="question-content">
    <div v-if="fullScreenLoading" class="loading">
      <looping-rhombuses-spinner :animation-duration="2500" :rhombus-size="30"
        :color="theme.themeColor.split(';')[0]" />
    </div>
    <div class="main-content" :class="{ 'box-full-screen': isFull }">
      <div class="inner-header">
        <span class="type-name">
          {{ questionTitle }}
          <span class="score">（{{ question.score || 0 }}分）</span>
          <span v-if="isExploreQuestion" class="explore-title-tip">
            <i class="el-icon-warning"></i>
            闯关成功，自动切换至下一题
          </span>
          <el-button v-if="isApplicationQuestion" type="primary" @click="openQuestionBackgroundModal">题目背景</el-button>
        </span>
        <div v-if="isExploreQuestion" class="box-full-btn" @click="isFull = !isFull">
          <i class="full" v-show="!isFull"></i><span v-show="!isFull">全屏</span>
          <i class="close" v-show="isFull"></i><span v-show="isFull">退出全屏</span>
        </div>
      </div>
      <div :class="`${isExploreQuestion ? 'scroll-box-passcode' : 'scroll-box'} ${isFull ? 'box-full-screen-content' : ''
        }`" ref="scrollBox">
        <div :class="isExploreQuestion ? 'question-wrap-passcode' : 'question-wrap'">
          <!--题目内容-->
          <div v-if="!isExploreQuestion" class="question-desc-audio-wrap">
            <div
              v-if="questionAudioUrl"
              class="question-audio-read-btn"
              role="button"
              tabindex="0"
              :class="{ playing: isAudioPlaying }"
              :style="{ color: theme && theme.themeColor ? theme.themeColor.split(';')[0] : undefined }"
              @click.stop="toggleReadQuestionAudio"
              @keydown.enter.stop.prevent="toggleReadQuestionAudio"
            >
              <svg v-if="!isAudioPlaying" width="18" height="18" viewBox="0 0 24 24" aria-hidden="true">
                <path
                  d="M3 10v4c0 .55.45 1 1 1h3l5 4V5l-5 4H4c-.55 0-1 .45-1 1z"
                  fill="currentColor"
                />
                <path
                  d="M14.5 9.5c1.32 1.32 1.32 3.68 0 5"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                />
                <path
                  d="M17 7c2.4 2.4 2.4 8.6 0 11"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                />
              </svg>
              <svg v-else width="18" height="18" viewBox="0 0 24 24" aria-hidden="true">
                <path
                  d="M3 10v4c0 .55.45 1 1 1h3l5 4V5l-5 4H4c-.55 0-1 .45-1 1z"
                  fill="currentColor"
                />
                <rect x="15" y="8" width="3.5" height="8" rx="1.25" fill="currentColor" />
                <rect x="19.5" y="8" width="3.5" height="8" rx="1.25" fill="currentColor" />
              </svg>
            </div>
            <div class="question-desc question-render-container"></div>
          </div>
          <!--填空题-->
          <div class="blank-wrap" v-if="question.typeId === EnumTypeId.FillSingle">
            <textarea placeholder="请在这里输入答案" class="blank-fill" @mouseenter="(event) => areaChange(event, true)"
              @mouseleave="(event) => areaChange(event)" :style="`border-color: ${theme.lightThemeColor}`"
              v-model.trim="answerMap[question.questionId]" rows="5"></textarea>
          </div>
          <!--单项选择题-->
          <ul class="option-wrap" v-if="question.typeId === EnumTypeId.ChoiceSingle">
            <li class="option" @mouseenter="(event) => styleChange(event, option, question.typeId, true)
              " @mouseleave="(event) => styleChange(event, option, question.typeId)
                " v-for="(option, index) in question.choice.choices" :key="index" :style="setStateStyle(option)"
              :class="{ 'is-select': option.submit_id === answerMap[question.questionId] }"
              @click="selectOption(option.submit_id)">
              <div class="option-name-wrap" :style="option.submit_id === answerMap[question.questionId]
                ? `background-color: ${theme.themeColor}`
                : `background-color: ${theme.lightThemeColor}`
                ">
                <span>{{ order[index] }}</span>
              </div>
              <div class="option-content">
                <p class="desc">{{ option.text }}</p>
                <div v-if="option.image" class="image">
                  <el-image :src="option.image" :preview-src-list="[option.image]">
                  </el-image>
                </div>
              </div>
            </li>
          </ul>
          <!--多项选择题-->
          <ul class="option-wrap" v-if="question.typeId === EnumTypeId.ChoiceMultiple">
            <li class="option" v-for="(option, index) in question.choice.choices" :key="`${question.questionId}-${option.submit_id}`"
              :style="setStateStyle(option)"
              :class="{ 'is-select': (answerMap[question.questionId] && answerMap[question.questionId].includes(option.submit_id)) }"
              @mouseenter="(event) => styleChange(event, option, question.typeId, true)"
              @mouseleave="(event) => styleChange(event, option, question.typeId)"
              @click="selectOption(option.submit_id)">
              <div class="option-name-wrap" :style="(answerMap[question.questionId] && answerMap[question.questionId].includes(option.submit_id))
                ? `background-color: ${theme.themeColor}`
                : `background-color: ${theme.lightThemeColor}`
                ">
                <span>{{ order[index] }}</span>
              </div>
              <div class="option-content">
                <p class="desc">{{ option.text }}</p>
                <div v-if="option.image" class="image">
                  <el-image :src="option.image" :preview-src-list="[option.image]">
                  </el-image>
                </div>
              </div>
            </li>
          </ul>
          <!--文件上传题-->
          <div
            class="blank-wrap"
            v-if="question.typeId === EnumTypeId.FileUpload"
          >
            <el-upload
              drag
              :key="'file-upload-' + question.questionId"
              class="file-upload-question"
              ref="fileUploadQuestionRef"
              action="#"
              :show-file-list="false"
              :http-request="handleFileQuestionHttpRequest"
              :file-list="fileUploadQuestionFileList"
              :limit="1"
              :auto-upload="true"
              :on-exceed="handleFileUploadExceed"
              :on-preview="handleFileUploadPreview"
              :on-remove="handleFileUploadRemove"
              :accept="fileUploadExt"
            >
              <div class="upload-area">
                <div class="upload-area-content">
                  <img :src="UploadIcon" alt="upload_icon" class="upload-content-icon" />
                    <div class="rp-upload-explain">{{`${question.cloudOperation.work_upload_explain}，支持格式：${question.cloudOperation.work_upload_file_ext_list && question.cloudOperation.work_upload_file_ext_list.join('/').toLocaleUpperCase()}`}}</div>
                    <div class="rp-upload-size">文件大小{{question.cloudOperation.work_upload_size_limit}}MB以内</div>
                </div>
              </div>
            </el-upload>

            <!-- 进度条 -->
            <div
              :class="{'file-upload-progress': true, 'progress-bottom': fileUploadProgress > 0 && fileUploadProgress < 100 }"
              v-show="fileUploadProgress > 0 || answerMap[question.questionId]"
            >
              <el-progress
                :percentage="fileUploadProgress"
                :stroke-width="10"
                :color="fileUploadProgressColor"
              />
            </div>

            <!-- 上传状态 -->
            <div
              v-if="fileUploadProgress === 100 || answerMap[question.questionId]"
              class="upload-result-wrap"
            >
            <div class="upload-result-text">
              <img :src="UploadIcon" alt="" class="upload-icon">
              <p
                v-if="fileUploadAnswerFileName && fileUploadProgress === 100"
                class="upload-result-filename"
                :title="fileUploadAnswerFileName"
                @click="downloadFile()"
              >{{ fileUploadAnswerFileName }}</p>
              <img
                class="upload-delete-icon"
                :src="DeleteIcon"
                v-if="fileUploadAnswerFileName && fileUploadProgress === 100"
                alt="删除"
                @click.stop="handleFileUploadQuestionDelete"
              />
            </div>
            <div class="upload-result-text">
              <div v-if="fileUploadAnswerFileName && fileUploadProgress === 100" class="upload-result-success">
                <img class="upload-result-icon" :src="UploadSuccessIcon" alt="">
                <span>上传成功</span>
              </div>
            <div v-if="!fileUploadAnswerFileName && fileUploadProgress === 100" class="upload-result-error">
              <img class="upload-result-icon" :src="UploadErrorIcon" alt="">
              <span class="upload-result-text-error">上传失败</span>
            </div>
            </div>
            </div>
          </div>
          <!--判断题-->
          <ul class="option-wrap" v-if="question.typeId === EnumTypeId.YesNo">
            <li class="option" @mouseenter="(event) => styleChange(event, option, question.typeId, true)
              " @mouseleave="(event) => styleChange(event, option, question.typeId)
                " v-for="(option, index) in question.yes_no.yes_no" :style="setStateStyle(option)" :key="index"
              :class="{ 'is-select': option.submit_id === answerMap[question.questionId] }"
              @click="selectOption(option.submit_id)">
              <div class="option-name-wrap" :style="option.submit_id === answerMap[question.questionId]
                ? `background-color: ${theme.themeColor}`
                : `background-color: ${theme.lightThemeColor}`
                ">
                <span>{{ order[index] }}</span>
              </div>
              <div class="option-content">
                <p class="desc">
                  {{ option.mark_yes_no === "YES" ? "对" : "错" }}
                </p>
              </div>
            </li>
          </ul>
          <div v-show="isOperateQuestion" class="operate-question-wrap" :class="{
            'explore-question-wrap': isExploreQuestion,
          }">
            <div v-show="isOperateQuestion" :class="isExploreQuestion ? 'tool-wrap-passcode' : 'tool-wrap'">
              <div v-show="isKittenN" ref="kittenN" class="editor" :class="{ 'full-screen': isFullScreen }"></div>
              <div v-show="!isKittenN" id="iframeWrap" class="editor" :class="{ 'full-screen': isFullScreen }"></div>

              <!--操作题，并且非闯关题-->
              <div v-if="!isExploreQuestion">
                <div class="countdown" :class="{
                  'py-countdown': question.questionType === EnumQuestionType.Python,
                  'scratch-countdown': question.questionType === EnumQuestionType.Scratch,
                  'tart-countdown': [EnumQuestionType.Cplusplus, EnumQuestionType.PythonOJ, EnumQuestionType.KittenN].includes(question.questionType),
                  'box3d-countdown': question.questionType === EnumQuestionType.Box3D,
                  'full-screen-position': isFullScreen,
                }" v-show="isFullScreen">
                  <span class="word">剩余时间</span>
                  <span class="time" v-if="endTime">{{
                    endTime | formateTime(countdown) | timeFactory
                  }}</span>
                </div>
                <div v-show="!loading && !isShowKittenNeedReload" class="toAnswer" @click="showFullScreen">
                  全屏作答<span class="arrow"></span>
                </div>
                <div v-show="isShowKittenNeedReload" class="toAnswer" @click="handleReloadIframe">
                  加载失败，请重新加载<span class="arrow"></span>
                </div>
                <div v-show="loading" class="toAnswer" style="cursor: default;">
                  作品加载中，请稍后...
                </div>
              </div>
            </div>
            <!-- 非闯关题才显示加载提示 -->
            <div v-show="!isExploreQuestion" class="operate-question-load-tips">
              <p class="operate-question-load-tips-title">【温馨提示】</p>
              <p class="operate-question-load-tips-content">
                如果当前作答工具长时间加载未完成，
              </p>
              <p class="operate-question-load-tips-content">
                请点击<span class="operate-question-load-tips-btn" @click="handleReloadIframe">重新加载</span>，重新加载工具。
              </p>
            </div>
          </div>

          <!--python文件上传题-->
          <div class="new-type-wrap" v-if="question.questionType === EnumQuestionType.PythonUpload">
            <button class="data-download" @click="downloadExamData(question.uploadUrl)">
              <i class="download-icon"></i>考试资料下载
            </button>
            <div class="upload-wrap">
              <p class="tip">
                请根据题目提示，打开海龟编辑器进行作答，作答完成根据要求上传答案
              </p>
              <button class="data-upload" @click="uploadFile" v-if="!answerMap[question.questionId]">
                <i class="upload-icon"></i>上传答案
              </button>
              <div class="answer-wrap" v-else>
                <i class="python-icon"></i>
                <div class="answer-info">
                  <p class="file-name">
                    {{
                      answerMap[question.questionId].split("/")[
                      answerMap[question.questionId].split("/").length - 1
                      ]
                    }}
                  </p>
                  <p class="upload-time">
                    {{
                      answerMap[question.questionId].split("/")[
                      answerMap[question.questionId].split("/").length - 2
                      ] | date("H:i")
                    }}
                    上传成功
                  </p>
                </div>
                <span class="change-btn" @click="uploadFile">修改作品</span>
              </div>
              <input type="file" style="display: none" @change="fileChange" ref="fileInput" />
            </div>
          </div>
        </div>
      </div>
      <!-- 答题区域操作按钮 -->
      <template v-if="!isFull">
        <div class="btn-wrap" v-show="!isFullScreen">
          <a class="prev" :class="!switchQuestionEnabled ? 'clickDisable' : ''"
            :style="`color: ${theme.themeColor} border: 1px solid ${theme.themeColor}`"
            @click="switchQuestionEnabled ? changeQuestion('prevQuestion') : null" v-show="!isFirst">上一题</a>
          <a class="next" :class="!switchQuestionEnabled ? 'clickDisable' : ''"
            :style="`background: ${theme.buttonBackground} box-shadow: ${theme.buttonShadow};`"
            @click="switchQuestionEnabled ? changeQuestion('nextQuestion') : null" v-show="!isLast">下一题</a>
          <a class="next" :class="!switchQuestionEnabled ? 'clickDisable' : ''"
            :style="`background: ${theme.buttonBackground} box-shadow: ${theme.buttonShadow}`"
            @click="switchQuestionEnabled ? submitPaper() : null" v-show="isLast">交卷</a>
        </div>
      </template>
    </div>

    <!-- 操作题全屏操作按钮 -->
    <div class="full-screen-btn" v-show="isFullScreen">
      <button
        v-if="isCppRealTimeOJ || isPythonRealTimeOJ"
        class="submit-oj-btn"
        :style="isCppRealTimeOJ ? 'background-color: #57b673' : undefined"
        @click="handleShowOjRealTimeResult"
      >
         查看结果
      </button>
      <button
        v-if="isCppRealTimeOJ || isPythonRealTimeOJ"
        class="submit-oj-btn"
        :style="isCppRealTimeOJ ? 'background-color: #57b673' : undefined"
        :disabled="isSubmittingOj"
        @click="handleSubmitOjRealTime(isCppRealTimeOJ ? 'c++' : 'python3')"
      >
        {{ getOjSubmitButtonText() }}
      </button>
      <button type="button" class="btn" @click="openDetail" :style="openBtnStyle">
        查看题目
      </button>
      <button class="btn" @click="saveWork" :disabled="saving" :style="'background:' + theme.themeColor">
        保存作品
      </button>
      <button class="btn" @click="outFullScreen" :style="'background:' + theme.themeColor">
        退出全屏
      </button>
      <button class="reset-ques" @click="showResetTip = true" :style="'color:' + theme.themeColor">
        重置
      </button>
      <div class="question-detail" :class="{ show: showDetail }">
        <i class="icon-close" @click="openDetail"></i>

        <div v-if="!isApplicationQuestion"  class="content question-render-container"></div>
        <el-tabs v-else v-model="activeTab" type="card">
          <el-tab-pane label="题目要求" name="content">
            <div class="question-render-container"></div>
          </el-tab-pane>
          <el-tab-pane label="题目背景" name="background">
            <div v-html="questionBackground"></div>
          </el-tab-pane>

        </el-tabs>
      </div>
    </div>

    <!-- 重置提示框 -->
    <modal width="450px" speed="fast" title="提示" noOutClose :show="showResetTip" enter-active-class="fadeIn"
      leave-active-class="fadeOut" @update:show="showResetTip = false">
      <div slot="content">
        <p style="font-size: 16px">
          重置操作将会清空所有修改恢复初始状态，是否继续？
        </p>
      </div>
      <div slot="footer">
        <button class="white-btn" @click="showResetTip = false">取消</button>
        <button class="blue-btn" @click="resetQues">确定</button>
      </div>
    </modal>

    <!--闯关题相关-->
    <modal width="410px" speed="fast" noHeader noFooter maskNoClick enter-active-class="fadeIn"
      leave-active-class="fadeOut" :show.sync="nextExploreVisible" class="next_explore_tip">
      <div slot="content">
        <i class="el-icon-success tip-icon"></i>
        <p class="tip-desc">
          闯关成功，用时{{ computeTime(exploreSuccessData.finishTime) }}
        </p>
        <p class="tip-result">
          <span class="tip-text">本次闯关使用积木：<span class="tip-text-bold">{{ exploreSuccessData.useBlockCount
              }}块</span></span>
          <span class="tip-text mr-20">最佳闯关使用积木：<span class="tip-text-bold">{{ exploreSuccessData.bestBlockCount
              }}块</span></span>
        </p>
        <div class="submit-btn-wrap">
          <button class="confirm" :style="`color: #666666 border: 1px solid #A1A1A1`" @click="exploreAginBtn">
            再闯本关
          </button>
          <div v-if="!isLast" class="tip-btn-next">
            <button class="continue" :style="`background: ${theme.buttonBackground} box-shadow: ${theme.buttonShadow}`"
              @click="exploreNextBtn">
              下一关
            </button>
            <span class="tip-text mt-10">
              <span class="tip-text-bold">5s</span>后自动跳到下一关
            </span>
          </div>
          <button v-else class="continue"
            :style="`background: ${theme.buttonBackground} box-shadow: ${theme.buttonShadow}`"
            @click="submitPaper()">
            提交答卷
          </button>
        </div>
      </div>
    </modal>
    <img v-show="exploreFailVisible" class="exploreFailStyle" :src="exploreFailImg" />
    <QuestionBackgroundModal ref="questionBackgroundModal" v-if="isApplicationQuestion" />
    <OJResultModal
      ref="ojResultModal"
      @retry="handleSubmitOjRealTime(isCppRealTimeOJ ? 'c++' : 'python3')"
      @downloadCode="handleDownloadCode"
    />
  </div>
</template>

<script>
import eventBus from '@/utils/eventBus'
import { get } from '@/utils/ajax'
import Modal from '@/components/Modal'
import { formateQuesType } from '@/utils/common'
import QuestionContentMixin from '@/mixins/QuestionContentMixin'
import { downloadData, getExamId } from '@/utils'
import { sdkUploader } from '@/utils/upload-sdk'
import Vue from 'vue/dist/vue'
import debounce from 'lodash/debounce'
import LoopingRhombusesSpinner from 'epic-spinners/src/components/lib/LoopingRhombusesSpinner'
// import * as Sentry from '@sentry/browser'
import { sensor } from '@/utils/sensor'
import { EnumTypeId, EnumQuestionType, Enum3DBoxType, isOperateQuestion, get3DBoxToken, get3DBoxInfo, reset3DBoxMap, initKittenN, getQuestionTypeText } from './handler'
import QuestionBackgroundModal from './QuestionBackgroundModal.vue'
import { Button, Tabs, TabPane, Upload, Progress } from 'element-ui'
import TartIframeApi from '@/utils/tartIframeApi'
import OJResultModal from './OJResultModal.vue'
import UploadSuccessIcon from '@/assets/images/upload_success_icon.png'
import UploadErrorIcon from '@/assets/base64/error_icon.js'
import UploadIcon from '@/assets/base64/upload_icon.js'
import DeleteIcon from '@/assets/images/upload_delete_icon.png'
import { getLastOjRealtimeCode, getLastOjRealtimeResult, getOjRealtimeResult } from '@/apis/ojRealtime.api'
import { getWood2CatBitPayload } from '@/utils/operation-question'
import { getRealTouristsToken } from '@/utils'

const FILE_UPLOAD_EMPTY_FILE_LIST = Object.freeze([])

/** 扩展名(大写) → el-upload 的 accept 片段（带点扩展名大小写 + MIME） */
const FILE_EXT_ACCEPT_MAP = Object.freeze({
  PDF: '.pdf,.PDF,application/pdf',
  JPG: '.jpg,.JPG,image/jpeg',
  JPEG: '.jpeg,.JPEG,image/jpeg',
  PNG: '.png,.PNG,image/png',
  BMP: '.bmp,.BMP,image/bmp',
  GIF: '.gif,.GIF,image/gif',
  TXT: '.txt,.TXT,text/plain',
  ZIP: '.zip,.ZIP,application/zip',
  DOC: '.doc,.DOC,application/msword',
  DOCX: '.docx,.DOCX,application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  RAR: '.rar,.RAR,application/vnd.rar',
  MP4: '.mp4,.MP4,video/mp4',
  MOV: '.mov,.MOV,video/quicktime'
})

/** 与 FILE_EXT_ACCEPT_MAP 对应，供 sdkUploader 的 MIME 校验 */
const FILE_EXT_MIME_MAP = Object.freeze({
  PDF: 'application/pdf',
  JPG: 'image/jpeg',
  JPEG: 'image/jpeg',
  PNG: 'image/png',
  BMP: 'image/bmp',
  GIF: 'image/gif',
  TXT: 'text/plain',
  ZIP: 'application/zip',
  DOC: 'application/msword',
  DOCX: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  RAR: 'application/vnd.rar',
  MP4: 'video/mp4',
  MOV: 'video/quicktime'
})

const FILE_UPLOAD_DEFAULT_EXTS = Object.freeze(['JPG', 'JPEG', 'PNG', 'BMP'])

export default {
  mixins: [QuestionContentMixin],
  components: {
    Modal,
    LoopingRhombusesSpinner,
    QuestionBackgroundModal,
    ElButton: Button,
    ElTabs: Tabs,
    ElTabPane: TabPane,
    ElUpload: Upload,
    ElProgress: Progress,
    OJResultModal
  },
  props: {
    questionList: {
      type: Array,
      default() {
        return []
      }
    },
    question: {
      type: Object,
      default() {
        return {}
      }
    },
    isFirst: {
      type: Boolean,
      default: false
    },
    isLast: {
      type: Boolean,
      default: false
    },
    switchQuestionEnabled: {
      type: Boolean,
      default: true
    },
    countdown: {
      type: Number
    },
    endTime: {
      type: Number
    }
  },
  filters: {
    // 页面倒计时
    formateTime(value, countdown) {
      const time = value - countdown
      return time
    },
    // 倒计时格式化
    timeFactory(timestamp) {
      timestamp = timestamp / 1000
      if (timestamp <= 0) {
        return '00 : 00 : 00'
      }
      let h = Math.floor(timestamp / 3600)
      let m = Math.floor((timestamp / 60) % 60)
      let s = Math.floor(timestamp % 60)
      h = h < 10 ? 0 + '' + h : h
      m = m < 10 ? 0 + '' + m : m
      s = s < 10 ? 0 + '' + s : s
      return h + ' : ' + m + ' : ' + s
    }
  },
  data() {
    return {
      UploadSuccessIcon,
      UploadErrorIcon,
      UploadIcon,
      DeleteIcon,
      activeTab: 'content',
      EnumTypeId,
      EnumQuestionType,
      order: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J'],
      answerMap: {}, // 答题记录
      fileUploadProgress: 0,
      isFullScreen: false, // 全屏作答
      fullScreenLoading: false, // 全屏loading
      timer: null, // 自动保存定时器
      showResetTip: false, // 重置弹窗
      showDetail: false, // 题目详情弹窗
      openBtnStyle: {}, // 查看题目按钮样式
      // 工具类型，ID作为唯一键
      operateIds: ['kitten', '', 'python', 'scratch', '', 'explore', 'cplusplus', 'python_oj', 'box3d', 'kitten_n', 'python_real_time_oj', 'cplusplus_real_time_oj', 'wood2_cloud'],
      // 工具初始化状态，questionType 的值为索引，3dbox和kitten_n比较特殊，不需要用到
      operateIniteds: [false, false, false, false, false, false, false, false, true, true, false, false, false],
      isReset: false,

      // 闯关题相关
      nextExploreVisible: false, // 是否展示闯关通过模态框
      exploreSuccessData: {
        bestBlockCount: 0,
        codeStr: '',
        finishTime: 0,
        msg: '',
        useBlockCount: 0
      }, // 闯关成功数据
      exploreFailImg: 'https://education.codemao.cn/27/exam/1/exploreFail.png', // 失败图形
      exploreFailVisible: false,
      nextTimeout: null,
      failTimeout: null,
      isFull: false,

      // 3dbox相关
      box3dWorkId: '',

      // kitten·n相关
      knSdk: null,
      knIniting: false,

      // 加载、保存状态控制
      loading: false,
      saving: false,
      isFiveSecondsEnd: false, // 还有5秒结束考试，进行一次操作题保存
      isSubmittingOj: false, // OJ提交状态
      ojSubmitCooldown: 0, // OJ提交冷却倒计时（秒）
      ojCooldownTimer: null, // OJ冷却定时器
      isKittenLoadError: false, // kitten加载失败
      // 读题音频
      questionAudioDom: null,
      questionAudioSrc: '',
      isAudioPlaying: false
    }
  },
  computed: {
    theme() {
      return this.$store.state.theme
    },
    fileUploadProgressColor() {
      const c = this.theme && this.theme.themeColor
      if (!c || typeof c !== 'string') return '#2863eb'
      return c.split(';')[0].trim() || '#2863eb'
    },
    // 是否是操作题
    isOperateQuestion() {
      return isOperateQuestion(this.question.questionType)
    },
    // 是否是闯关题
    isExploreQuestion() {
      return this.question.questionType === EnumQuestionType.Explore
    },
    // 是否是Kitten·N编程操作题
    isKittenN() {
      return this.question.questionType === EnumQuestionType.KittenN
    },
    isShowKittenNeedReload() {
      return this.question.questionType === EnumQuestionType.Kitten && this.isKittenLoadError && !this.loading
    },
    /** 根据题目配置的扩展名生成 el-upload 的 accept（与 FILE_EXT_ACCEPT_MAP 一致） */
    fileUploadExt() {
      const list = this.question.cloudOperation && (this.question.cloudOperation.work_upload_file_ext_list || [])
      const keys =
        !Array.isArray(list) || !list.length
          ? FILE_UPLOAD_DEFAULT_EXTS
          : list.map((item) => item.toUpperCase())
      const parts = keys.map((k) => FILE_EXT_ACCEPT_MAP[k]).filter(Boolean)
      const joined = [...new Set(parts)].join(',')
      return (
        joined ||
        FILE_UPLOAD_DEFAULT_EXTS.map((k) => FILE_EXT_ACCEPT_MAP[k]).filter(Boolean).join(',')
      )
    },
    fileUploadUpperCaseExt() {
      const list = this.question.cloudOperation && (this.question.cloudOperation.work_upload_file_ext_list || [])
      const keys =
        !list || !Array.isArray(list) || !list.length
          ? FILE_UPLOAD_DEFAULT_EXTS
          : list.map((item) => String(item).toUpperCase())
      return keys
    },
    /** 与 fileUploadExt 对应的 MIME 列表，供 sdkUploader */
    fileUploadSdkMimeAccept() {
      const mimes = this.fileUploadUpperCaseExt.map((k) => FILE_EXT_MIME_MAP[k]).filter(Boolean)
      const joined = [...new Set(mimes)].join(',')
      return (
        joined ||
        FILE_UPLOAD_DEFAULT_EXTS.map((k) => FILE_EXT_MIME_MAP[k]).filter(Boolean).join(',')
      )
    },
    // 应用题名称
    questionTitle() {
      const question = this.questionList.find(item => item.questionId === this.question.questionId)
      if (!question) {
        return ''
      }
      if (question.suiteType === 1) {
        const suiteId = question.suiteId
        const suiteIdList = this.questionList.filter(item => item.suiteType === 1).map(item => item.suiteId).filter((item, index, self) => self.indexOf(item) === index)
        return `应用题 ${suiteIdList.indexOf(suiteId) + 1}`
      }
      return this.formateType(question.typeId, question.questionType)
    },
    isApplicationQuestion() {
      const question = this.questionList.find(item => item.questionId === this.question.questionId)
      if (!question) {
        return false
      }
      return question.suiteType === 1
    },
    questionBackground() {
      const question = this.questionList.find(item => item.questionId === this.question.questionId)
      if (!question || question.suiteType !== 1) {
        return ''
      }
      return question.suiteContent
    },
    isCppRealTimeOJ() {
      return this.question.questionType === EnumQuestionType.CplusplusRealTimeOJ
    },
    isPythonRealTimeOJ() {
      return this.question.questionType === EnumQuestionType.PythonRealTimeOJ
    },
    isCatbitQuestion() {
      return (
        this.question.questionType === EnumQuestionType.Wood2Cloud && // wood2云模式的题目
        !!this.getWood2CloudStartWork()
      ) // 存在预置文件
    },

    // 后端在题目信息中返回的读题音频地址
    questionAudioUrl() {
      return this.question.audio_url ? this.question.audio_url : ''
    },
    /** 文件上传题：与 answerMap 同步，供 el-upload 展示已传文件 */
    fileUploadQuestionFileList() {
      const url = this.answerMap[this.question.questionId]
      if (!url) return FILE_UPLOAD_EMPTY_FILE_LIST
      const parts = String(url).split('/')
      let name = parts[parts.length - 1] || '已上传文件'
      try {
        name = decodeURIComponent(name)
      } catch (e) {
        /* ignore */
      }
      return [
        {
          name,
          url,
          status: 'success',
          uid: `file-upload-${this.question.questionId}`
        }
      ]
    },
    /** 文件上传题：已提交文件的展示名（有 URL 时非空） */
    fileUploadAnswerFileName() {
      const url = this.answerMap[this.question.questionId]
      if (!url) return ''
      const parts = String(url).split('/')
      const uploadName = parts[parts.length - 1]
      let name = uploadName.slice(13, uploadName.length) || '已上传文件'
      try {
        name = decodeURIComponent(name)
      } catch (e) {
        /* ignore */
      }
      return name
    }
  },
  watch: {
    questionAudioUrl: {
      immediate: true,
      handler(newUrl) {
        if (!newUrl) {
          this.stopReadQuestionAudio(true)
          return
        }
        // 题目切换：只准备音频，不自动播放
        this.prepareReadQuestionAudio(newUrl)
      }
    },
    question: {
      handler: function (val) {
        // 题目切换时停止并复位读题音频
        this.stopReadQuestionAudio(true)
        this.fileUploadProgress = 0
        // 切换题目时清除OJ提交倒计时
        this.clearOjSubmitCooldown()

        // 非闯关类型
        if (val.questionType !== EnumQuestionType.Explore) {
          this.isFull = false
        }
        if (val.answer) {
          // 初始化考生已答题目答案
          switch (val.typeId) {
            case EnumTypeId.ChoiceSingle:
            case EnumTypeId.YesNo:
              this.$set(this.answerMap, val.questionId, Number(val.answer))
              break
            case EnumTypeId.ChoiceMultiple:
              const values = val.answer.map(el => Number(el))
              this.$set(this.answerMap, val.questionId, values)
              break
            case EnumTypeId.KittenN:
              this.$set(this.answerMap, val.questionId, JSON.parse(val.answer))
              break
            case EnumTypeId.FileUpload:
              this.$set(this.answerMap, val.questionId, val.answer)
              break
            default:
              this.$set(this.answerMap, val.questionId, val.answer)
          }
        }
        const url = this.answerMap[this.question.questionId]
        if (url) {
          this.fileUploadProgress = 100
        }
        // 渲染题目
        this.renderRawDescription(val.rawDescription)
        this.$nextTick(() => {
          this.$refs.scrollBox.scrollTop = 0
          this.initIframe()
        })

        // 检查是否需要自动展示题目背景
        this.checkShouldShowBackgroundAuto(val.questionId)
      },
      deep: true,
      immediate: true
    },
    countdown(value) {
      const num = this.endTime - value
      if (this.endTime && !this.isFiveSecondsEnd && num <= 30000) {
        this.isFiveSecondsEnd = true
      }
    },
    // 还有五秒钟结束考试，如果正在全屏作答，则保存一次答案
    isFiveSecondsEnd(value) {
      if (value && this.isOperateQuestion && this.isFullScreen) {
        this.saveWork()
      }
    }
  },
  methods: {
    // ========== 读题音频 ==========
    onQuestionAudioEnded() {
      this.isAudioPlaying = false
      if (this.questionAudioDom) {
        this.questionAudioDom.currentTime = 0
      }
    },
    onQuestionAudioPlay() {
      this.isAudioPlaying = true
    },
    onQuestionAudioPause() {
      // 只有在非 ended 状态时才更新；ended 会走 ended 回调统一复位
      if (this.questionAudioDom && this.questionAudioDom.ended) return
      this.isAudioPlaying = false
    },
    onQuestionAudioError() {
      this.isAudioPlaying = false
      this.$message.error('读题音频播放失败')
    },
    prepareReadQuestionAudio(url) {
      if (!url) return

      // 新题目音频：复位并替换 src，但不自动播放
      this.stopReadQuestionAudio(true)

      if (!this.questionAudioDom) {
        this.questionAudioDom = new Audio()
        this.questionAudioDom.addEventListener('ended', this.onQuestionAudioEnded)
        this.questionAudioDom.addEventListener('play', this.onQuestionAudioPlay)
        this.questionAudioDom.addEventListener('pause', this.onQuestionAudioPause)
        this.questionAudioDom.addEventListener('error', this.onQuestionAudioError)
      }

      this.questionAudioSrc = url
      this.questionAudioDom.src = url
      this.questionAudioDom.preload = 'auto'
      this.questionAudioDom.load()
      this.questionAudioDom.currentTime = 0
      this.isAudioPlaying = false
    },
    stopReadQuestionAudio(resetCurrentTime = false) {
      if (this.questionAudioDom) {
        try {
          this.questionAudioDom.pause()
          if (resetCurrentTime) {
            this.questionAudioDom.currentTime = 0
          }
        } catch (e) {
          /* ignore */
        }
      }
      this.isAudioPlaying = false
    },
    cleanupReadQuestionAudio() {
      if (this.questionAudioDom) {
        try {
          this.questionAudioDom.pause()
          this.questionAudioDom.removeEventListener('ended', this.onQuestionAudioEnded)
          this.questionAudioDom.removeEventListener('play', this.onQuestionAudioPlay)
          this.questionAudioDom.removeEventListener('pause', this.onQuestionAudioPause)
          this.questionAudioDom.removeEventListener('error', this.onQuestionAudioError)
        } catch (e) {
          /* ignore */
        }
      }
      this.questionAudioDom = null
      this.questionAudioSrc = ''
      this.isAudioPlaying = false
    },
    toggleReadQuestionAudio() {
      const url = this.questionAudioUrl
      if (!url) return

      // 如果还没准备好，或 src 发生变化，先准备音频
      if (!this.questionAudioDom || this.questionAudioSrc !== url) {
        this.prepareReadQuestionAudio(url)
      }

      if (!this.questionAudioDom) return

      // 暂停/播放切换
      if (this.questionAudioDom.paused) {
        const playPromise = this.questionAudioDom.play()
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(() => {
            this.isAudioPlaying = false
            this.$message.error('读题音频播放失败')
          })
        }
      } else {
        this.questionAudioDom.pause()
      }
    },
    // 初始化操作题
    async initIframe() {
      const { questionType } = this.question
      // 当前题目是操作题
      if (this.isOperateQuestion) {
        this.createIframe(questionType)
        this.hideIframe(questionType)
      }
    },
    // 创建操作题dom节点
    async createIframe(questionType) {
      const id = this.operateIds[questionType]
      let url = ''
      switch (questionType) {
        case EnumQuestionType.Kitten: // kitten
          url = `${CONFIG.ide}?in_edu_lesson=true`
          break
        case EnumQuestionType.Python: // python
          url = CONFIG.python
          break
        case EnumQuestionType.Scratch: // scratch
          url = `${CONFIG.scratch}?work_url=https://education.codemao.cn/27/exam/1/1598446666000/scratch_default.sb3`
          break
        case EnumQuestionType.Explore: // 闯关
          url = this.question.uploadUrl
          break
        case EnumQuestionType.Cplusplus: // c++
        case EnumQuestionType.CplusplusRealTimeOJ:
          url = CONFIG.cplusplus
          break
        case EnumQuestionType.PythonOJ: // python_oj
        case EnumQuestionType.PythonRealTimeOJ:
          url = CONFIG.python_oj
          break
        case EnumQuestionType.Wood2Cloud: // 木头云
          url = CONFIG.wood2_cloud
          break
        case EnumQuestionType.Box3D: // 3dbox
          // 先置为空，等创建完iframe后再去加载作品
          url = ''
          break
        case EnumQuestionType.KittenN: // kitten·n
          // Kitten·N题型使用sdk，需特殊处理，不走iframe创建逻辑
          this.loading = true
          this.initKittenN()
          return
      }
      const iframeWrap = document.querySelector('#iframeWrap')
      const hasIframe = iframeWrap.querySelector(`#${id}`) // 是否已存在该题型的iframe
      if (hasIframe) {
        // 直接加载当前题目内容
        this.loadWork()
      } else {
        this.loading = true

        // 创建新的Iframe
        // 创建构造器
        const Profile = Vue.extend({
          template:
            '<iframe :src="url" :id="id" width="100%" height="100%" class="if-common" allow="microphone;camera;midi;encrypted-media;accelerometer;gyroscope;usb"></iframe>',
          data: function () {
            return {
              url: url,
              id: id
            }
          }
        })
        // 创建 Profile 实例，并挂载
        iframeWrap.appendChild(new Profile().$mount().$el)

        sensor.track('question_iframe_created', {
          questionId: this.question.questionId,
          questionType: this.question.questionType,
          questionName: this.question.questionName,
          questionTypeId: this.question.typeId
        })

        // 如果是3DBox，第一次创建也需要去加载loadWork
        if (questionType === EnumQuestionType.Box3D) {
          this.loadWork()
        }
      }
    },
    /** limit=1 时再次选文件会触发：先清空再上传，实现覆盖 */
    handleFileUploadExceed(files) {
      const ref = this.$refs.fileUploadQuestionRef
      if (!ref || !files || !files.length) return
      const raw = files[0]
      if (!raw) return
      this.$set(this.answerMap, this.question.questionId, '')
      ref.clearFiles()
      this.$nextTick(() => {
        this.$nextTick(() => {
          const inner = ref.$refs['upload-inner']
          if (inner && typeof inner.uploadFiles === 'function') {
            inner.uploadFiles([raw])
          }
        })
      })
    },
    handleFileUploadPreview(file) {
      if (file.url) {
        window.open(file.url, '_blank', 'noopener,noreferrer')
      }
    },
    handleFileUploadRemove() {
      this.$set(this.answerMap, this.question.questionId, '')
      this.fileUploadProgress = 0
      this.saveAnswer('saveQuestion')
    },
    /** 点击删除图标：移除已上传文件并重置上传区 */
    handleFileUploadQuestionDelete() {
      const ref = this.$refs.fileUploadQuestionRef
      if (ref && typeof ref.clearFiles === 'function') {
        ref.clearFiles()
      }
      this.$set(this.answerMap, this.question.questionId, '')
      this.fileUploadProgress = 0
    },
    async handleFileQuestionHttpRequest(option) {
      const { file, onSuccess, onError, onProgress } = option
      const maxMb = Number(this.question.cloudOperation.work_upload_size_limit) || 10
      const limitBytes = maxMb * 1024 * 1024

      try {
        // qiniu-js 进度为 { total: { loaded, size, percent } }，与 XHR ProgressEvent、裸 number 不同
        const toPercent = (ev) => {
          if (ev == null) return 0
          if (typeof ev === 'number') {
            if (ev >= 0 && ev <= 1) return Math.min(100, Math.round(ev * 100))
            return Math.min(100, Math.max(0, Math.round(ev)))
          }
          if (typeof ev === 'object') {
            const t = ev.total
            if (t && typeof t === 'object') {
              if (typeof t.percent === 'number' && !isNaN(t.percent)) {
                return Math.min(100, Math.max(0, Math.round(t.percent)))
              }
              if (typeof t.loaded === 'number' && typeof t.size === 'number' && t.size > 0) {
                return Math.min(100, Math.round((t.loaded / t.size) * 100))
              }
            }
            if (typeof ev.loaded === 'number' && typeof ev.total === 'number' && ev.total > 0) {
              return Math.min(100, Math.round((ev.loaded / ev.total) * 100))
            }
            if (ev.percent != null) return Math.min(100, Math.round(Number(ev.percent)))
          }
          return 0
        }

        let lastPercent = 0
        const reportProgress = (ev) => {
          let p = toPercent(ev)
          // 七牛 PUT 完成会先报到 100%，但 sdk onsuccess 仍可能晚于 mkfile/回调；展示上限 99%，真正结束再置 100
          if (p >= 100) p = 99
          lastPercent = Math.max(lastPercent, p)
          this.fileUploadProgress = lastPercent
          if (onProgress) onProgress({ percent: this.fileUploadProgress })
        }

        this.fileUploadProgress = 0
        const res = await sdkUploader(file, {
          accept: this.fileUploadSdkMimeAccept,
          limit: limitBytes,
          limitText: '上传文件超过限制',
          onprogress: reportProgress,
          customTypeMessage: '该类型文件不支持上传'
        })
        this.$set(this.answerMap, this.question.questionId, res.url)
        this.$message.success('上传成功！')
        this.fileUploadProgress = 100
        if (onProgress) onProgress({ percent: 100 })
        onSuccess(res, file)
      } catch (e) {
        if (!e || (e.type !== 'mime' && e.type !== 'size')) {
          this.$message.error('上传失败，请重试！')
          this.fileUploadProgress = 100
        }
        onError(e)
      }
    },
    downloadFile() {
      const url = this.answerMap[this.question.questionId]
      downloadData(url)
    },
    // 隐藏iframe
    hideIframe(type) {
      const id = this.operateIds[type]
      const iframeWrap = document.querySelectorAll('.if-common')
      iframeWrap.forEach((item) => {
        item.style.display = item.id === id ? 'block' : 'none'
      })
    },
    // 下载考试资料
    downloadExamData(url) {
      downloadData(url)
    },
    // 打开上传选择
    uploadFile() {
      this.$refs.fileInput.click()
    },
    // 上传新题型答案到七牛云
    async fileChange(e) {
      const file = e.target.files[0]
      this.$refs.fileInput.value = ''

      try {
        const res = await sdkUploader(file)
        this.$set(this.answerMap, this.question.questionId, res.url)
        this.$message.success('上传成功！')
      } catch (e) {
        this.$message.error('上传失败，请重试！')
      }
    },
    setStateStyle(option) {
      let style = ''
      if (option.submit_id === this.answerMap[this.question.questionId]) {
        style = `border: 1px solid ${this.theme.themeColor}`
        return style
      }
      return `border: 1px solid ${this.theme.lightThemeColor}`
    },
    areaChange(e, useTheme) {
      if (useTheme) {
        e.target.style = `border-color: ${this.theme.themeColor}`
      } else {
        e.target.style = `border-color: ${this.theme.lightThemeColor}`
      }
    },
    styleChange(e, option, typeId, useTheme) {
      const answer = this.answerMap[this.question.questionId]
      if ((typeId === 1 || typeId === 6) && option.submit_id === answer) {
        e.target.querySelector(
          '.option-name-wrap'
        ).style = `border-right: none; background-color: ${this.theme.themeColor}`
        return
      }
      if (typeId === 2 && answer && answer.includes(option.submit_id)) {
        e.target.querySelector(
          '.option-name-wrap'
        ).style = `border-right: none; background-color: ${this.theme.themeColor}`
        return
      }
      if (useTheme) {
        e.target.style = `border: 1px solid ${this.theme.themeColor}`
        e.target.querySelector(
          '.option-name-wrap'
        ).style = `border-right: 1px solid ${this.theme.themeColor}
        background-color: ${this.theme.lightThemeColor}`
      } else {
        e.target.style = ''
        e.target.querySelector(
          '.option-name-wrap'
        ).style = `border-right: none; background-color: ${this.theme.lightThemeColor}`
      }
    },
    // 全屏开启定时保存
    showFullScreen() {
      this.isFullScreen = true
      this.$emit('changeStyle', true)
      this.autoSave()
    },
    // 退出全屏关闭定时
    outFullScreen() {
      this.isFullScreen = false
      this.showDetail = false
      this.$emit('changeStyle', false)
      this.saveWork()
      clearInterval(this.timer)
      this.activeTab = 'content'
    },
    // 单选题、多选题、判断题选择选项
    selectOption(id) {
      let answer = this.answerMap[this.question.questionId]
      // 多选题
      if (this.question.typeId === 2) {
        answer = answer instanceof Array ? answer.slice() : []
        if (answer.includes(id)) {
          answer.splice(answer.indexOf(id), 1)
        } else {
          answer.push(id)
        }
      } else {
        answer = id
      }
      this.$set(this.answerMap, this.question.questionId, answer)
    },
    // 重置操作题题目
    resetQues() {
      this.isReset = true
      this.showResetTip = false
      this.fullScreenLoading = true
      this.loadWork()
    },
    // 查看题目详情
    openDetail() {
      this.showDetail = !this.showDetail
      this.openBtnStyle = {
        background: this.showDetail
          ? '#fff'
          : `${this.theme.themeColor.split(';')[0]}`,
        color: this.showDetail
          ? `${this.theme.themeColor.split(';')[0]}`
          : '#fff',
        border: this.showDetail
          ? `1px solid ${this.theme.themeColor.split(';')[0]}`
          : 'none'
      }
    },
    formateType(id, questionType = 5) {
      return formateQuesType(id, questionType)
    },
    // 开始时禁止切题操作
    excuteExplore() {
      this.$emit('changeQuesEnabled', false)
    },
    // 停止时允许切题操作
    stopExplore() {
      this.$emit('changeQuesEnabled')
    },
    // 闯关数据存储
    saveExploreData(data) {
      this.$emit('saveExplore', {
        which: 'saveExplore',
        steps: data.useBlockCount,
        finishTime: data.finishTime,
        answer: { url: data.codeStr },
        currentId: this.question.questionId,
        successCallback: () => {
          this.stopExplore()
          this.exploreSuccessData = data
          this.nextExploreVisible = true
          if (!this.isLast) {
            this.nextTimeout = setTimeout(() => {
              this.nextExploreVisible = false // 先关闭模态框再执行下一关
              this.exploreNextBtn()
            }, 6000)
          }
        },
        failCallback: () => {
          this.stopExplore()
          this.exploreAginBtn()
        }
      })
    },
    // 再闯本关
    exploreAginBtn: debounce(
      function () {
        clearTimeout(this.nextTimeout)
        this.nextExploreVisible = false
        const explore = document.getElementById('explore')
        explore.contentWindow.postMessage(
          { msg: 'ExplorerRestart' },
          CONFIG.explorer
        )
      },
      3000,
      {
        leading: true,
        trailing: false
      }
    ),
    // 下一关
    exploreNextBtn: debounce(
      function () {
        clearTimeout(this.nextTimeout)
        this.nextExploreVisible = false
        this.changeQuestion('nextQuestion')
      },
      3000,
      {
        leading: true,
        trailing: false
      }
    ),
    // 闯关失败提示
    exploreFail() {
      clearTimeout(this.failTimeout)
      this.exploreFailVisible = true
      this.failTimeout = setTimeout(() => {
        this.stopExplore()
        this.exploreFailVisible = false
        this.exploreAginBtn()
      }, 3000)
    },
    // 计算用时
    computeTime(t) {
      const hasHour = Math.floor(t / 60)
      const h = hasHour / 60 > 1 ? `${hasHour}时` : ''
      const m = hasHour > 60 ? `${hasHour % 60}分` : `${hasHour}分`
      const s = `${t % 60}秒`
      return `${h}${m}${s}`
    },
    // 初始化Tart工具 type= 'py_oj' | 'cpp_oj'
    initTart(type) {
      let tart = null
      let domain = '*'
      let exportName = ''
      switch (type) {
        case 'py_oj':
          tart = document.getElementById('python_oj')
          domain = CONFIG.python_oj
          exportName = 'exportAsPythonFile'
          break
        case 'cpp_oj':
          tart = document.getElementById('cplusplus')
          domain = CONFIG.cplusplus
          exportName = 'exportAsCppFile'
          break
        default:
          throw new Error('未知编辑器')
      }

      if (!tart) return
      const tartWindow = tart.contentWindow

      tartWindow.postMessage(
        {
          type: 'FEATURE_SET_CONFIG',
          payload: {
            headerDisabled: false, // 默认展示头部栏，true 则隐藏
            headerLogoDisabled: true, // 默认展示头部栏中的Logo，true 则隐藏
            headerFileMenuDisabled: false, // 默认展示头部栏中的文件菜单，true 则隐藏
            headerFileMenuItems: [
              // 'createProject',
              // 'openProjectManager',
              // 'workSaveAs',
              // 'divider',
              // 'openLocalFile',
              exportName
              // 'divider',
              // 'importMiaoLink',
              // 'exportAsMiaoLink',
            ], // 默认展示所有头部栏文件菜单选项，[] 则隐藏所有
            userAvatarDisabled: true, // 默认展示用户头像，true 则隐藏
            workSaveButtonDisabled: true, // 默认展示作品保存按钮，true 则隐藏
            workNameInputDisabled: true, // 默认展示作品名称输入框，true 则隐藏
            disabledRegExp: true // 默认隐藏正则配置，false 则展示
          }
        },
        domain
      )
    },
    initKitten() {
      // 初始化kitten配置项
      const kitten = document.getElementById('kitten')
      if (!kitten) return
      const kittenWindow = kitten.contentWindow
      kittenWindow.postMessage(
        {
          type: 'kitten_set_ui',
          content: {
            header: {
              file: true, // 展示文件按钮
              export_file: true, // 展示保存作品到本地
              setting: true, // 展示设置按钮
              language: true, // 展示语言切换
              save: false // 隐藏保存按钮
            }
          }
        },
        CONFIG.ide
      )
    },
    initPython() {
      const python = document.getElementById('python')
      if (!python) return
      const pythonWindow = python.contentWindow
      // 设为代码模式
      pythonWindow.postMessage({ msg: 'set_default_mode', mode: 'code' }, CONFIG.python)
      // 隐藏切换积木模式按钮
      pythonWindow.postMessage({ msg: 'set_mode_btn_display', mode: 'false' }, CONFIG.python)
      // 隐藏自带的缩放按钮
      pythonWindow.postMessage({ msg: 'set_fullscreen_btn_display', is_display: false }, CONFIG.python)
      // 隐藏帮助按钮
      pythonWindow.postMessage({ msg: 'set_help_btn_display', is_display: false }, CONFIG.python)
      // 打开海龟绘图
      pythonWindow.postMessage({ msg: 'set_turtle_canvas_display', is_display: true }, CONFIG.python)
    },
    // 3分钟自动保存
    autoSave() {
      this.timer = setInterval(() => {
        this.saveWork()
      }, 180000)
    },
    // 加载作品
    async loadWork() {
      this.loading = true
      const { questionId, questionType } = this.question

      // 是否初始化完成
      const inited = this.operateIniteds[questionType]
      if (!inited) {
        return
      }

      const iframeId = this.operateIds[questionType]
      const iframe = document.getElementById(iframeId)
      if (!iframe && !this.isKittenN) {
        return
      }
      const iframeWindow = iframe && iframe.contentWindow
      const answer = this.answerMap[questionId]

      let loadType
      if (this.isReset) {
        loadType = 'reset'
      } else if (answer) {
        loadType = 'answer'
      } else {
        loadType = 'preset'
      }

      sensor.track('question_content_load_start', {
        questionId: this.question.questionId,
        questionType: getQuestionTypeText(this.question.typeId, this.question.questionType),
        questionName: this.question.questionName,
        loadType
      })

      switch (questionType) {
        case EnumQuestionType.Kitten: // kitten
          let bcmUrl = this.question.kitten.start_bcm.url
          if (answer && !this.isReset) {
            if (typeof answer === 'string') {
              try {
                const { bcm_url } = await get(`/edu/exams/works/kitten?code=${answer}`)
                bcmUrl = bcm_url
                sensor.track('kitten_answer_get_result', {
                  questionId: this.question.questionId,
                  questionType: getQuestionTypeText(this.question.typeId, this.question.questionType),
                  answer,
                  bcmUrl,
                  result: 'success'
                })
              } catch (e) {
                sensor.track('kitten_answer_get_result', {
                  questionId: this.question.questionId,
                  questionType: getQuestionTypeText(this.question.typeId, this.question.questionType),
                  answer,
                  result: 'failed',
                  reason: JSON.stringify({
                    error_code: e.error_code || '',
                    error_msg: e.error_msg || ''
                  })
                })
              }
            } else {
              bcmUrl = answer.url
            }
          }
          iframeWindow.postMessage({ type: 'load_bcm', content: bcmUrl }, CONFIG.ide)

          // 打开素材库
          if (this.question.kittenMaterialLoad === 1) {
            iframeWindow.postMessage({
              type: 'kitten_set_ui',
              content: { sprite_panel: { material_dialog: true } }
            }, CONFIG.ide)
          }
          break
        case EnumQuestionType.Scratch: // scratch
          let sb3Url = this.question.uploadUrl
          if (answer && !this.isReset) {
            sb3Url = answer
          }
          iframeWindow.postMessage({ type: 'load_sb3', content: sb3Url }, CONFIG.scratch)
          break
        case EnumQuestionType.Explore: // explore
          iframe.src = this.question.uploadUrl
          break
        case EnumQuestionType.Python: // python
        case EnumQuestionType.Cplusplus: // c++
        case EnumQuestionType.PythonOJ: // python_oj
        case EnumQuestionType.PythonRealTimeOJ: // python_real_time_oj
        case EnumQuestionType.CplusplusRealTimeOJ: // cplusplus_real_time_oj
          let code = this.question.operation.template_source_code
          if (this.answerMap[questionId] && !this.isReset) {
            code = this.answerMap[questionId]
          }
          if (questionType === EnumQuestionType.Python) { // python
            iframeWindow.postMessage({ msg: 'set_python_code', code: code }, CONFIG.python)
          } else { // c++ 或 python_oj 或 python_real_time_oj 或 cplusplus_real_time_oj
            let ext = 'cpp'
            let domain = CONFIG.cplusplus
            if (questionType === EnumQuestionType.PythonRealTimeOJ) {
              ext = 'py'
              domain = CONFIG.python_oj
            } else if (questionType === EnumQuestionType.CplusplusRealTimeOJ || questionType === EnumQuestionType.Cplusplus) {
              ext = 'cpp'
              domain = CONFIG.cplusplus
            }

            iframeWindow.postMessage({
              type: 'WORK_OPEN',
              payload: {
                work: {
                  work_id: 0,
                  name: '新的作品',
                  extension: ext,
                  content: code,
                  version: 0
                }
              }
            }, domain)
          }
          this.loading = false
          if (this.isReset) {
            this.isReset = false
            this.fullScreenLoading = false
            this.$message.success('重置成功！')
          }
          break
        case EnumQuestionType.Box3D: // 3dbox
          let editUrl = ''
          if (this.isReset) {
            const info = await this.fetchReset3DBox()
            editUrl = info.url
          } else {
            const info = await this.fetch3DBoxInfo()
            editUrl = info.url
          }
          iframe.src = editUrl
          break
        case EnumQuestionType.KittenN: // kitten_n
          try {
            let work = {
              type: 'courseUrl',
              courseUrl: this.question.cloudOperation.start_work
            }
            if (answer && !this.isReset) {
              work = {
                type: 'workId',
                workId: answer.workId
              }
            }
            await this.knSdk.application.loadWork({ work })
            sensor.track('question_content_load_result', {
              questionId: this.question.questionId,
              questionType: 'Kitten·N',
              questionName: this.question.questionName,
              result: 'success'
            })
            this.loading = false
            if (this.isReset) {
              this.isReset = false
              this.fullScreenLoading = false
              this.$message.success('重置成功！')
            }
          } catch (e) {
            sensor.track('question_content_load_result', {
              questionId: this.question.questionId,
              questionType: 'Kitten·N',
              questionName: this.question.questionName,
              result: 'failed'
            })
            this.$message.error('作品加载失败，请稍后重试 ！')
          }
          break
        case EnumQuestionType.Wood2Cloud: // wood2_cloud
          let wood2CloudCode = this.question.operation.template_source_code
          if (this.answerMap[questionId] && !this.isReset) {
            wood2CloudCode = this.answerMap[questionId]
          }

          let wood2CloudPayload = {
            work_id: 0,
            work_name: '新的作品',
            content: [{
              work_id: 0,
              file_id: -49,
              file_name: 'main.py',
              source: wood2CloudCode,
              open: true,
              pid: 0,
              file_type: 2
            }],
            update_time: new Date().getTime(),
            language_type: 3
          }

          const presetStartWork = this.getWood2CloudStartWork()
          // 小猫板的题目，答案是JSON字符串，需要解析成对象
          if (this.isCatbitQuestion) {
            // 获取预置文件内容
            // 如果答案存在，则解析答案
            if (this.answerMap[questionId] && !this.isReset) {
              try {
                wood2CloudPayload = JSON.parse(this.answerMap[questionId])
              } catch (e) {
                // 解析答案预置文件失败，则使用预置文件
                console.error('解析答案预置文件失败', e)
                if (presetStartWork) {
                  const presetPayload = await getWood2CatBitPayload(presetStartWork)
                  if (presetPayload) {
                    wood2CloudPayload = presetPayload
                  }
                }
              }
            } else if (presetStartWork) {
              const presetPayload = await getWood2CatBitPayload(presetStartWork)
              if (presetPayload) {
                wood2CloudPayload = presetPayload
              }
            }
          }

          iframeWindow.postMessage({
            type: 'RESET_EDITOR_STATUS'
          }, CONFIG.wood2_cloud)

          iframeWindow.postMessage({
            type: 'SET_CURRENT_WOOD_PROJECT',
            payload: wood2CloudPayload
          }, CONFIG.wood2_cloud)
          this.loading = false
          if (this.isReset) {
            this.isReset = false
            this.fullScreenLoading = false
            this.$message.success('重置成功！')
          }
          break
      }
    },
    // 通知工具保存
    async saveWork() {
      this.saving = true
      if (!this.isFullScreen) {
        this.$emit('showSaveLoading')
      }
      const questionType = this.question.questionType
      const id = this.operateIds[questionType]
      const iframe = document.getElementById(id)
      if (!iframe && !this.isKittenN) {
        this.saving = false
        return
      }

      sensor.track('question_tool_save_work_start', {
        questionId: this.question.questionId,
        questionType: getQuestionTypeText(this.question.typeId, this.question.questionType),
        questionName: this.question.questionName
      })

      const iframeWindow = iframe && iframe.contentWindow
      switch (questionType) {
        case EnumQuestionType.Kitten: // kitten
        case EnumQuestionType.Scratch: // scratch
          iframeWindow.postMessage({
            type: 'save_work_by_ticket',
            content: {
              x_ticket: window.sessionStorage.getItem('QINIUTOKEN'),
              question_id: this.question.questionId
            }
          }, questionType === EnumQuestionType.Kitten ? CONFIG.ide : CONFIG.scratch)
          break
        case EnumQuestionType.Python: // python
          iframeWindow.postMessage({ msg: 'get_python_code' }, CONFIG.python)
          break
        case EnumQuestionType.Cplusplus: // c++
        case EnumQuestionType.PythonOJ: // python_oj
        case EnumQuestionType.PythonRealTimeOJ: // python_real_time_oj
        case EnumQuestionType.CplusplusRealTimeOJ: // cplusplus_real_time_oj
          let domain = CONFIG.cplusplus
          if (
            questionType === EnumQuestionType.PythonRealTimeOJ || // python 实时判题
            questionType === EnumQuestionType.PythonOJ // python oj
          ) {
            domain = CONFIG.python_oj
          }
          iframeWindow.postMessage({ type: 'WORK_GET_CURRENT_DATA' }, domain)
          break
        case EnumQuestionType.Box3D: // 3dbox
          this.saving = false
          this.$set(this.answerMap, this.question.questionId, this.box3dWorkId)
          this.saveAnswer('save3DBox')
          break
        case EnumQuestionType.KittenN: // Kitten·N
          const workName = `${this.question.questionId}_${this.question.questionName}`
          try {
            const data = await this.knSdk.application.saveWork({
              workName
            })
            this.saving = false
            this.$set(this.answerMap, this.question.questionId, {
              workId: data.body.workId,
              url: data.body.url
            })
            sensor.track('question_tool_save_work_result', {
              questionId: this.question.questionId,
              questionType: 'Kitten·N',
              questionName: this.question.questionName,
              workId: data.body.workId,
              url: data.body.url,
              result: 'success'
            })
            this.saveAnswer('saveKittenN')
          } catch (e) {
            this.saving = false
            this.$message.error('保存作品失败，请重新保存')
            // Sentry.captureEvent({
            //   message: '作品保存失败',
            //   extra: e && e.message
            // })
            sensor.track('question_tool_save_work_result', {
              questionId: this.question.questionId,
              questionType: 'Kitten·N',
              questionName: this.question.questionName,
              result: 'failed',
              reason: e.message || e.error_msg || 'unknown'
            })
          }
          break
        case EnumQuestionType.Wood2Cloud: // wood2_cloud
          iframeWindow.postMessage({ type: 'GET_CURRENT_WOOD_PROJECT',
            payload: {
              nct: {}
            } }, CONFIG.wood2_cloud)
          break
        default:
          this.$message.error('未知操作题')
          break
      }
    },
    changeQuestion(which) {
      // 如果不是操作题，做保存动作
      if (!this.isOperateQuestion) {
        this.saveAnswer('saveQuestion')
      }
      this.$emit('changeQuestion', {
        which,
        currentId: this.question.questionId
      })
    },
    // 保存答案
    saveAnswer(which, data) {
      const { questionId, ...rest } = (data || {})
      const currentId = questionId || this.question.questionId
      const answer = this.answerMap[currentId]
      this.$emit('saveAnswer', {
        which,
        answer,
        currentId,
        ...rest
      })
    },
    // 交卷
    submitPaper() {
      this.$emit('submitPaper')
    },
    // 操作题接收 postMessage 消息
    iframeMessage(e) {
      const questionType = this.question.questionType
      const message = e.data || e.value || {}
      const workName = `${this.question.questionId}_${this.question.questionName}`
      switch (message.type) {
        case 'exam_save_end': // kitten/scratch 保存作品结果

          let isExamSaveError = false
          try {
            isExamSaveError = message.content.content.status === 'error'
          } catch (e) {
            isExamSaveError = false
          }

          let examSaveResultText
          try {
            examSaveResultText = JSON.stringify(message)
          } catch (e) {
            examSaveResultText = 'unknown'
          }

          sensor.track('question_tool_save_work_result', {
            questionId: this.question.questionId,
            questionType: getQuestionTypeText(this.question.typeId, this.question.questionType),
            questionName: this.question.questionName,
            result: isExamSaveError ? 'failed' : 'success',
            resultText: examSaveResultText
          })

          if (isExamSaveError) {
            this.saving = false
            let failType = 'unknown'
            if (message.content.content.error_type === 'token_expired') {
              failType = 'token_expired'
              this.$message.error('登录态失效，请重新登录')
              this.$emit('showLoginDialog')
            } else {
              this.$message.error('保存作品失败，请重新保存')
            }
            // Sentry.captureEvent({
            //   message: '作品保存失败',
            //   extra: message.content
            // })
            sensor.track('save_work_failed', {
              workName,
              msg: message.content,
              type: failType
            })
          } else {
            const url = message.content.content.bcm_url ||
              message.content.content.sb3_url

            if (!url) {
              this.saving = false
              this.$message.error('保存作品失败，请重新保存')
              // Sentry.captureEvent({
              //   message: '作品保存成功，但没有返回作品链接',
              //   extra: message.content
              // })
              sensor.track('save_work_failed', {
                workName,
                msg: message.content,
                type: 'no_url'
              })
              return
            }

            const questionId = message.content.content.question_id
            this.$set(this.answerMap, questionId, { url })
            if (message.platform === 'scratch') {
              this.saveAnswer('saveScratch', {
                questionId,
                successCallback: () => {
                  this.saving = false
                },
                failCallback: () => {
                  this.saving = false
                }
              })
            } else {
              this.saveAnswer('saveKitten', {
                questionId,
                successCallback: () => {
                  this.saving = false
                },
                failCallback: () => {
                  this.saving = false
                }
              })
            }
          }
          break
        case 'exam_login_fail':
          this.loading = false
          this.saving = false
          this.$message.error('登录态失效，请重新登录')
          this.$emit('showLoginDialog')
          break
        case 'scratch_loaded': // scratch工具初始化完成
          sensor.track('question_iframe_init_success', {
            questionId: this.question.questionId,
            questionType: getQuestionTypeText(this.question.typeId, this.question.questionType),
            questionName: this.question.questionName
          })

          this.operateIniteds[EnumQuestionType.Scratch] = true
          if (questionType === EnumQuestionType.Scratch) {
            this.loadWork()
          }
          break
        case 'exam_load_bcm_end': // 加载bcm的结果
          this.loading = false

          let resultText
          try {
            resultText = JSON.stringify(message)
          } catch (e) {
            resultText = 'unknown'
          }

          let isError
          try {
            isError = message.content.content.status === 'error'
            if (isError) {
              this.isKittenLoadError = true
            }
          } catch (e) {
            isError = false
          }

          sensor.track('question_content_load_result', {
            questionId: this.question.questionId,
            questionType: getQuestionTypeText(this.question.typeId, this.question.questionType),
            questionName: this.question.questionName,
            resultText,
            result: isError ? 'failed' : 'success'
          })
          if (isError) {
            this.$emit('openSlowTip', 'loadQues')
            return
          }

          if (this.isReset) {
            this.isReset = false
            this.fullScreenLoading = false
            this.$message.success('重置成功！')
          }
          break
        case 'exam_load_sb3_end': // 加载sb3的结果
          this.loading = false

          let resultText2
          try {
            resultText2 = JSON.stringify(message)
          } catch (e) {
            resultText2 = 'unknown'
          }
          let isError2
          try {
            isError2 = message.content.content.status === 'error'
          } catch (e) {
            isError2 = false
          }
          sensor.track('question_content_load_result', {
            questionId: this.question.questionId,
            questionType: getQuestionTypeText(this.question.typeId, this.question.questionType),
            questionName: this.question.questionName,
            resultText: resultText2,
            result: isError2 ? 'failed' : 'success'
          })
          if (isError2) {
            this.$emit('openSlowTip', 'loadQues')
            return
          }
          if (this.isReset) {
            this.isReset = false
            this.fullScreenLoading = false
            this.$message.success('重置成功！')
          }
          break
        case 'IFRAME_READY': // c++、python_oj工具初始化完成
          sensor.track('question_iframe_init_success', {
            questionId: this.question.questionId,
            questionType: getQuestionTypeText(this.question.typeId, this.question.questionType),
            questionName: this.question.questionName
          })
          this.operateIniteds[questionType] = true

          if (CONFIG.wood2_cloud.includes(e.origin)) {
            this.initWood2Cloud()
            return
          }

          this.initTart(message.payload.page)
          if ([
            EnumQuestionType.Cplusplus,
            EnumQuestionType.PythonOJ,
            EnumQuestionType.PythonRealTimeOJ,
            EnumQuestionType.CplusplusRealTimeOJ
          ].includes(questionType)) {
            this.loadWork()
          }
          break
        case 'WORK_CURRENT_DATA': // c++、python_oj获取作品成功
          sensor.track('question_tool_save_work_result', {
            questionId: this.question.questionId,
            questionType: getQuestionTypeText(this.question.typeId, this.question.questionType),
            questionName: this.question.questionName,
            result: 'success'
          })
          this.saving = false
          this.$set(this.answerMap, this.question.questionId, message.payload.work.content)
          if ([EnumQuestionType.Cplusplus, EnumQuestionType.CplusplusRealTimeOJ].includes(questionType)) {
            this.saveAnswer('saveCplusplus')
          } else if ([EnumQuestionType.PythonOJ, EnumQuestionType.PythonRealTimeOJ].includes(questionType)) {
            this.saveAnswer('savePythonOj')
          }
          break
        case 'WORK_GET_CURRENT_DATA_FAILED': // c++、python_oj获取作品失败

          sensor.track('question_tool_save_work_result', {
            questionId: this.question.questionId,
            questionType: getQuestionTypeText(this.question.typeId, this.question.questionType),
            questionName: this.question.questionName,
            result: 'failed'
          })

          this.saving = false
          this.$message.error('保存作品失败，请重新保存')

          break
        case 'CURRENT_WOOD_PROJECT':
          sensor.track('question_tool_save_work_result', {
            questionId: this.question.questionId,
            questionType: getQuestionTypeText(this.question.typeId, this.question.questionType),
            questionName: this.question.questionName,
            result: 'success'
          })

          // 小猫板的题目，将获取到的整个文件夹作为答案
          if (this.isCatbitQuestion) {
            const sourceCode = message.payload
            this.$set(this.answerMap, this.question.questionId, JSON.stringify(sourceCode))
          } else {
            const sourceCode = message.payload.content[0].source
            this.$set(this.answerMap, this.question.questionId, sourceCode)
          }
          this.saving = false
          this.saveAnswer('saveWood2Cloud')
          break
      }
      switch (message.msg) {
        case 'wood_is_ready': // python初始化完成
          sensor.track('question_iframe_init_success', {
            questionId: this.question.questionId,
            questionType: getQuestionTypeText(this.question.typeId, this.question.questionType),
            questionName: this.question.questionName
          })
          this.operateIniteds[EnumQuestionType.Python] = true
          this.initPython()
          if (questionType === EnumQuestionType.Python) {
            this.loadWork()
          }
          break
        case 'python_code': // python获取作品成功
          sensor.track('question_tool_save_work_result', {
            questionId: this.question.questionId,
            questionType: getQuestionTypeText(this.question.typeId, this.question.questionType),
            questionName: this.question.questionName,
            result: 'success'
          })
          this.saving = false
          this.$set(this.answerMap, this.question.questionId, message.code)
          this.saveAnswer('savePython')
          break
        case 'ExplorerStopExecute':
          this.stopExplore()
          break
        case 'ExplorerStartExecute':
          this.excuteExplore()
          break
        case 'ExplorerInit':
          sensor.track('question_iframe_init_success', {
            questionId: this.question.questionId,
            questionType: getQuestionTypeText(this.question.typeId, this.question.questionType),
            questionName: this.question.questionName
          })
          this.operateIniteds[EnumQuestionType.Explore] = true
          this.loading = false
          break
        case 'ExplorerTaskSuccess':
          this.saveExploreData(message)
          break
        case 'ExplorerTaskFail':
          this.exploreFail()
          break
      }
      switch (message.content) {
        case 'kitten_is_ready': // kitten初始化完成并且空白作品加载完成后才能去加载预置作品
          sensor.track('question_iframe_init_success', {
            questionId: this.question.questionId,
            questionType: getQuestionTypeText(this.question.typeId, this.question.questionType),
            questionName: this.question.questionName
          })
          this.operateIniteds[EnumQuestionType.Kitten] = true
          this.initKitten()
          if (questionType === EnumQuestionType.Kitten) {
            this.loadWork()
          }
          break
      }
      switch (message.eventType) {
        case 'cm:trans:codemao:status': // 3dbox加载完成
          if (message.eventParams === 'interactable') {
            this.loading = false
            if (this.isReset) {
              this.isReset = false
              this.fullScreenLoading = false
              this.$message.success('重置成功！')
            }
          }
          break
        case 'cm:trans:nct:logout': // 3dbox授权token失效
          this.loading = false
          this.saving = false
          get3DBoxToken()
          this.$message.error('授权Token失效，请稍后重试')
          break
      }
    },
    // 获取3DBox地址
    async fetch3DBoxInfo() {
      try {
        const info = await get3DBoxInfo({
          type: Enum3DBoxType.Create,
          questionId: this.question.questionId,
          title: `${this.question.questionId}_${this.question.questionName}`
        })
        this.box3dWorkId = info.workId
        return info
      } catch (e) {
        this.$message.error(e.message)
        return { url: '' }
      }
    },
    // 重置3DBox作品
    async fetchReset3DBox() {
      try {
        const info = await reset3DBoxMap({
          questionId: this.question.questionId,
          workId: this.box3dWorkId
        })
        return info
      } catch (e) {
        this.$message.error(e.message)
        this.isReset = false
        this.fullScreenLoading = false
        throw e
      }
    },
    // 初始化Kitten·N
    async initKittenN() {
      if (this.knIniting) {
        return
      }
      this.knIniting = true
      try {
        // 先销毁，再初始化
        if (this.knSdk) {
          this.knSdk.application.destroy()
          this.knSdk = null
        }
        this.knSdk = await initKittenN({
          container: this.$refs.kittenN
        })
        if (getRealTouristsToken()) {
          await this.knSdk.application.setUserData({
            token: getRealTouristsToken(),
          })
        }
        sensor.track('question_iframe_created', {
          questionId: this.question.questionId,
          questionType: getQuestionTypeText(this.question.typeId, this.question.questionType),
          questionName: this.question.questionName
        })
        sensor.track('question_iframe_init_success', {
          questionId: this.question.questionId,
          questionType: getQuestionTypeText(this.question.typeId, this.question.questionType),
          questionName: this.question.questionName
        })
        this.knIniting = false
        if (this.question.questionType === EnumQuestionType.KittenN) {
          this.loadWork()
        }
      } catch (e) {
        this.knIniting = false
        this.$message.error('Kitten·N加载失败，请刷新页面重试')
        // Sentry.captureEvent({
        //   message: 'Kitten·N加载失败',
        //   extra: e.message
        // })
        sensor.track('kn_load_failed', {
          workName: `${this.question.questionId}_${this.question.questionName}`,
          msg: e && e.message
        })
      }
    },
    openQuestionBackgroundModal() {
      this.$refs.questionBackgroundModal.handleOpen(this.questionTitle, this.questionBackground)
    },
    checkShouldShowBackgroundAuto(questionId) {
      setTimeout(() => {
        if (!this.isApplicationQuestion) {
          return
        }
        const isHadAutoShowBackground = localStorage.getItem(`isHadAutoShowBackground_${questionId}`)
        if (isHadAutoShowBackground) {
          return false
        }
        localStorage.setItem(`isHadAutoShowBackground_${questionId}`, true)
        this.openQuestionBackgroundModal()
      }, 300)
    },
    async handleShowOjRealTimeResult() {
      this.$refs.ojResultModal.open()
      try {
        const serviceResult = await getLastOjRealtimeResult({
          examId: this.$route.query.examId || getExamId(),
          questionId: this.question.questionId
        })
        const resultData = this.processOJResult(serviceResult)
        this.$refs.ojResultModal.showResult(resultData)
      } catch (error) {
        console.error(error)
        this.$refs.ojResultModal.close()
        this.$message.error('获取上一次判题结果失败')
      }
    },
    formatMemory(memory) {
      if (memory < 1000) {
        return `${memory}B`
      } else if (memory < 1000 * 1000) {
        return `${(memory / 1000).toFixed(2)}KB`
      } else if (memory < 1000 * 1000 * 1000) {
        return `${(memory / 1000 / 1000).toFixed(2)}MB`
      } else {
        return `${(memory / 1000 / 1000 / 1000).toFixed(2)}GB`
      }
    },
    // 处理OJ判题结果
    processOJResult(res) {
      const testCases = res.result.map((item) => {
        // 如果output末尾字符为\n，则去掉
        const status = item.pointResult
        return {
          status,
          runtime: item.timeCost + 'ms',
          memory: this.formatMemory(item.memoryCost)
        }
      })

      const passed = res.pass
      const failed = res.notPass

      return {
        total: testCases.length,
        passed,
        failed,
        testCases
      }
    },
    async handleSubmitOjRealTime(lang) {
      if (this.isSubmittingOj || this.ojSubmitCooldown > 0) {
        return
      }

      this.isSubmittingOj = true
      const domainOrigin = lang === 'c++' ? CONFIG.cplusplus : CONFIG.python_oj
      try {
        const questionType = this.question.questionType
        const iframeId = this.operateIds[questionType]
        const iframe = document.getElementById(iframeId)
        if (!iframe) {
          throw new Error('iframe not found')
        }
        const tartIframeApi = new TartIframeApi(iframe.contentWindow, domainOrigin)
        const testDatas = this.question.operation.test_datas
        const { content: code } = await tartIframeApi.getContent()
        if (!code.trim()) {
          this.$message.error('请输入代码')
          this.isSubmittingOj = false
          return
        }
        this.$refs.ojResultModal.open()
        const { result, submission_id, isInterrupted, isTimeout } = await TartIframeApi.runMultiCases({
          language: lang,
          code,
          case_list: testDatas,
          submissionIdCallback: (submissionId) => {
            this.$refs.ojResultModal.setSubmissionId(submissionId)
          }
        })

        if (isTimeout) {
          this.$refs.ojResultModal.showTimeout()
          this.isSubmittingOj = false
          return
        }

        if (isInterrupted) {
          this.$refs.ojResultModal.close()
          this.isSubmittingOJ = false // 提交完成，恢复状态
          return
        }

        if (result.state === 'FAILED') {
          this.$message.error('代码运行失败，请检查后重试')
          this.$refs.ojResultModal.close()
          this.isSubmittingOj = false
          return
        } else if (result.compile_state === 'FAILED') {
          this.$message.error('代码编译失败，请检查后重试')
          this.$refs.ojResultModal.close()
          this.isSubmittingOj = false
          return
        }
        // 从后端获取提交结果和比对结果
        const serviceResult = await getOjRealtimeResult({
          submissionId: submission_id,
          examId: this.$route.query.examId || getExamId(),
          code,
          questionId: this.question.questionId
        })
        this.startOjSubmitCooldown()
        // 处理判题结果
        const resultData = this.processOJResult(serviceResult)
        this.$refs.ojResultModal.showResult(resultData)
      } catch (error) {
        console.error(error)
        this.$refs.ojResultModal.close()
        this.$message.error('代码编译失败，请检查后重试')
      } finally {
        this.isSubmittingOj = false
      }
    },
    async handleDownloadCode() {
      const { code } = await getLastOjRealtimeCode({
        examId: this.$route.query.examId || getExamId(),
        questionId: this.question.questionId
      })

      const a = document.createElement('a')
      a.href = `data:text/plain;charset=utf-8,${encodeURIComponent(code)}`
      a.download = 'code.txt'
      a.click()
    },
    // 获取OJ提交按钮文本
    getOjSubmitButtonText() {
      if (this.isSubmittingOj) {
        return '提交中...'
      }
      if (this.ojSubmitCooldown > 0) {
        return `${this.ojSubmitCooldown}S`
      }
      return '提交OJ'
    },
    // 启动OJ提交冷却倒计时
    startOjSubmitCooldown() {
      this.ojSubmitCooldown = 40
      this.ojCooldownTimer = setInterval(() => {
        this.ojSubmitCooldown--
        if (this.ojSubmitCooldown <= 0) {
          this.clearOjSubmitCooldown()
        }
      }, 1000)
    },
    // 清除OJ提交冷却倒计时
    clearOjSubmitCooldown() {
      if (this.ojCooldownTimer) {
        clearInterval(this.ojCooldownTimer)
        this.ojCooldownTimer = null
      }
      this.ojSubmitCooldown = 0
    },
    initWood2Cloud() {
      const iframe = document.getElementById(this.operateIds[EnumQuestionType.Wood2Cloud])
      iframe.contentWindow.postMessage(
        {
          type: 'SET_FEATURE_CONFIG',
          payload: {
            disabledFileExplorerContextMenu: false,
            disabledHeaderProjectMenu: false,
            headerProjectMenuItems: ['exportWoodProjectFile']
          }
        },
        CONFIG.wood2_cloud
      )
      this.loadWork()
    },
    handleReloadIframe() {
      const questionType = this.question.questionType

      // kn 不需要iframe, 所以单独处理
      if (questionType === EnumQuestionType.KittenN) {
        this.loading = true
        this.initKittenN()
        return
      }

      const iframeId = this.operateIds[questionType]
      /**
       * @type {HTMLIFrameElement}
       */
      const iframe = document.getElementById(iframeId)
      if (!iframe) {
        throw new Error('iframe not found')
      }
      this.loading = true
      if (questionType === EnumQuestionType.Box3D) {
        this.loadWork()
      } else {
        const src = iframe.src
        iframe.src = ''
        setTimeout(() => {
          iframe.src = src
        }, 100)
      }
    },
    getWood2CloudStartWork() {
      let startWork = this.question.start_work
      if (!startWork && this.question.operation) {
        startWork = this.question.operation.start_work
      }
      return startWork
    }
  },
  created() {
    // 保存题目答题
    eventBus.$on('saveQuestion', (id) => {
      const answer = this.answerMap[id]
      if (answer) {
        this.$emit('saveAnswer', {
          which: 'saveQuestion',
          answer,
          currentId: id
        })
      }
    })
  },
  mounted() {
    this.openBtnStyle = {
      background: `${this.theme.themeColor.split(';')[0]}`,
      color: '#fff',
      border: 'none'
    }
    window.addEventListener('message', this.iframeMessage)
  },
  destroyed() {
    clearInterval(this.timer)
    this.clearOjSubmitCooldown()
    window.removeEventListener('message', this.iframeMessage)
    this.cleanupReadQuestionAudio()
  }
}
</script>
<style>
.el-image-viewer__mask {
  cursor: pointer;
}

.el-image-viewer__close {
  top: 80px;
  width: 48px;
  height: 48px;
  background: rgba(0, 0, 0, 0.4);
}

.el-icon-circle-close::before {
  content: "\e6db";
  color: #fff;
  font-size: 24px;
  line-height: 48px;
  font-weight: bold;
}

.el-popover {
  z-index: 2 !important;
}
</style>
<style lang="scss" scoped>
@keyframes loadingCircle {
  100% {
    transform: rotate((360deg));
  }
}

.exploreFailStyle {
  position: absolute;
  z-index: 999;
  width: 550px;
  transform: translate(50%, 10%);
}

.next_explore_tip {
  /deep/ .modal-head {
    border-bottom: none;
  }

  .tip {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 20px;
    color: #333;
    font-size: 20px;
    font-weight: 500;
  }

  .tip-icon {
    color: #23be80;
    font-size: 49px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .icon-right {
    display: inline-block;
    width: 11px;
    height: 9px;
    opacity: 1;
  }

  .icon-sigh {
    display: inline-block;
    width: 5px;
    height: 16px;
    opacity: 1;
  }

  .big-circle {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    margin-bottom: 10px;
  }

  .small-circle {
    width: 22px;
    height: 22px;
    border-radius: 50%;
    opacity: 1;
  }

  .tip-desc {
    font-size: 18px;
    color: #333;
    font-weight: 500;
    color: #333333;
    line-height: 25px;
    text-align: center;
    margin: 15px 0;
  }

  .tip-result {
    display: flex;
    margin-bottom: 40px;
    justify-content: center;
  }

  .tip-text {
    font-size: 14px;
    font-weight: 400;
    color: #9b9b9b;
    line-height: 20px;
  }

  .tip-text-bold {
    color: #000000;
  }

  .mr-20 {
    margin-left: 20px;
  }

  .mt-10 {
    margin-top: 10px;
  }

  .tip-btn-next {
    display: flex;
    flex-direction: column;
    align-items: end;
  }

  .submit-btn-wrap {
    width: 100%;
    padding-bottom: 10px;
    display: flex;
    justify-content: center;

    .continue {
      @include theme-fill-btn(140px, 42px, 14px, 4px);
      margin-left: 20px;
    }

    .confirm {
      @include theme-empty-btn(140px, 42px, 14px, 4px);
    }
  }

  .left-btn-wrap {
    width: 100%;
    text-align: center;

    .confirm {
      @include theme-fill-btn(96px, 36px, 14px, 4px);
    }
  }
}

.question-content {
  height: 100%;
  flex: 1;
  display: flex;

  .scroll-box {
    position: relative;
    height: calc(100% - 120px);
    padding-top: 20px;
    overflow: auto;

    &::-webkit-scrollbar {
      width: 10px;
      height: 1px;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 10px;
      -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
      background: #666;
    }

    &::-webkit-scrollbar-track {
      -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
      border-radius: 10px;
      background: #f7f7f7;
    }
  }

  .scroll-box-passcode {
    position: relative;
    height: calc(100% - 120px);
    padding: 10px;
    border: 1px solid #b9d7ff;
    border-radius: 8px;
    overflow: auto;

    &::-webkit-scrollbar {
      width: 10px;
      height: 1px;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 10px;
      -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
      background: #666;
    }

    &::-webkit-scrollbar-track {
      -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
      border-radius: 10px;
      background: #f7f7f7;
    }
  }

  .question-wrap {
    position: relative;
  }

  .question-wrap-passcode {
    height: 100%;
    min-height: 340px;
  }

  .btn-wrap {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    border-top: 1px solid #f2f7ff;
    height: 82px;
    width: 100%;
    background-color: rgba(255, 255, 255, 0.9);
    z-index: 5;

    .next-tooltip {
      display: flex;
    }

    .next {
      @include theme-fill-btn(160px, 42px, 16px, 4px);
    }

    .prev {
      margin-right: 20px;
      @include theme-empty-btn(160px, 42px, 16px, 4px);
    }

    .clickDisable {
      color: #999999 !important;
      background: #f7f7f7 !important;
      border: 1px solid #d0d0d0 !important;
      cursor: not-allowed !important;
      box-shadow: none !important;
    }
  }

  /deep/ .el-radio__input.is-checked .el-radio__inner {
    background-color: $themeColor;
    border-color: $themeColor;
  }

  /deep/ .el-radio__input.is-checked+.el-radio__label {
    color: $themeColor;
  }

  /deep/ .el-radio__input+.el-radio__label {
    color: #333;
    font-weight: 400;
  }

  /deep/ .el-radio__inner:hover {
    border-color: $themeColor;
  }
}
/deep/ .el-tabs__content {
  height: calc(100vh - 200px);
  overflow: auto;
}

.main-content {
  height: 100%;
  flex: 1;
  background-color: #fff;
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.1);
  border-radius: 8px 8px 0 0;
  padding: 20px;
  position: relative;
  overflow: hidden;
}

.explore-title-tip {
  font-size: 12px;
  font-weight: 400;
  color: #8c8c8c;
  line-height: 17px;
}

.inner-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 10px;
  margin-bottom: 10px;

  .type-name {
    width: 50%;
    display: flex;
    align-items: center;
    font-size: 24px;
    font-weight: 500;
    color: #333;
    line-height: 32px;

    .score {
      color: #666;
      font-weight: 400;
    }
  }

  .submit-btn {
    width: 136px;
    height: 44px;
    border-radius: 21px;
    background: linear-gradient(270deg,
        rgba(255, 167, 33, 1) 0%,
        rgba(255, 202, 33, 1) 100%);
    box-shadow: 0 6px 8px 0 rgba(255, 155, 0, 0.4);
    color: #fff;
    font-size: 16px;
    font-weight: 300;
    cursor: pointer;

    &:hover {
      opacity: 0.8;
    }

    .icon-submit {
      display: inline-block;
      width: 28px;
      height: 28px;
      background: url("~@/assets/images/icon-submit.png") center / cover no-repeat;
      margin-right: 5px;
      margin-top: 2px;
    }
  }
}

.question-desc {
  margin-bottom: 30px;
  font-size: 18px;
  line-height: 27px;
  letter-spacing: 0.5px;
  max-width: 960px;

  /deep/ img {
    max-width: 100%;
    max-height: 360px;
    width: auto;
    height: auto;
  }
}

.question-desc-audio-wrap {
  display: flex;
  align-items: flex-start;
  max-width: 960px;
}

.question-audio-read-btn {
  position: static;
  margin-right: 12px;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background: rgba(0, 0, 0, 0.06);
  transition: transform 0.12s ease, background 0.12s ease;

  &:hover {
    transform: scale(1.06);
    background: rgba(0, 0, 0, 0.1);
  }

  svg {
    display: block;
  }

  &.playing {
    background: rgba(0, 200, 120, 0.15);
  }
}

.question-desc-audio-wrap .question-desc {
  flex: 1 1 auto;
}

.blank-wrap {
  margin-bottom: 30px;

  .file-upload-question {
    /deep/ .el-upload {
      display: block;
      width: 100%;

      /* 覆盖 element-ui：.el-upload:focus 会把 color 设为主题色，导致说明文字变蓝 */
      &:focus {
        color: #ccc;
      }
    }

    /* drag：插槽被包在 .el-upload-dragger 内，主题默认 width:360px height:180px overflow:hidden，会压乱布局 */
    /deep/ .el-upload-dragger {
      width: 60%;
      max-width: 100%;
      min-height: 60px;
      max-height: 300px;
      margin-top: 24px;
      box-sizing: border-box;
      background-color: #fafafa;
      border: 1px dashed #d9d9d9;
      border-radius: 8px;
      overflow: visible;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      cursor: pointer;

      .upload-area {
        width: 100%;
        min-height: 0;
        flex: 1 1 auto;
        margin-top: 0;
        padding: 0;
        border: none;
        border-radius: 0;
        background: transparent;
      }
    }

    /* 非 drag：热区框线画在 .upload-area 自身 */
    .upload-area {
      border: 1px dashed #d9d9d9;
      border-radius: 8px;
      width: 60%;
      height: 300px;
      background: #fafafa;
      padding: 32px 24px;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 24px;
      cursor: pointer;

      .upload-area-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
      }

      .upload-content-icon {
        width: 64px;
        height: 64px;
        margin-bottom: 16px;
      }
    }
  }

  .file-upload-progress {
    width: 60%;
    margin-top: 16px;
    padding: 0 4px;
    padding-bottom: 0;
    /deep/ .el-progress-bar {
      width: 100%;
      padding-right: 0;
    }
    /deep/ .el-progress__text {
      text-align: center;
      position: absolute;
      top: 30px;
      left: 50%;
      transform: translateX(-50%);
      color: #666;
    }
  }

  .progress-bottom {
    padding-bottom: 100px;
  }
  .upload-result-wrap {
    display: flex;
    justify-content: space-between;
    width: 60%;
    height: 60px;
    margin-top: 56px;
    padding: 12px 16px;
    background: #f1f5f9;
    border: none;
    border-radius: 8px;
    font-size: 14px;
    line-height: 1.6;

    .upload-result-text {
      display: flex;
      align-items: center;
      .upload-icon {
        width: 36px;
        height: 36px;
        margin-right: 8px;
      }
    }
    .upload-result-filename {
      max-width: 360px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      word-break: break-all;
      color: #333;
      cursor: pointer;
      color: #377DFD;
    }

    .upload-delete-icon {
      width: 16px;
      height: 16px;
      margin-left: 8px;
      cursor: pointer;
    }
    .upload-result-success {
      display: flex;
      align-items: center;
      color: #52c41a;
      font-weight: 500;
    }
    .upload-result-icon {
      width: 24px;
      height: 24px;
      margin-right: 4px;
    }
    .upload-result-error {
      display: flex;
      align-items: center;
      color: #f5222d;
      font-weight: 500;
    }
  }

  .blank-fill {
    width: 480px;
    border: 1px solid #d9d9d9;
    border-radius: 4px;
    padding: 10px 20px;
    line-height: 22px;
    font-size: 16px;
    resize: none;
    min-height: 44px;
    word-break: break-all;

    &:focus,
    &:hover {
      border-color: $themeColor;
    }

    &::placeholder {
      font-size: 16px;
      color: #bbb;
    }
  }
}

.tool-wrap-passcode {
  width: 100%;
  height: 100%;
  border-radius: 8px;
}

.tool-wrap {
  width: 500px;
  height: 333px;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
}

.editor {
  width: 100%;
  height: 100%;
  background-color: #fff;

  // transition: all 0.4s linear;
  &.full-screen {
    width: calc(100% - 100px);
    position: fixed;
    top: 0;
    left: 0;
    // bottom: 0;
    // right: 98px;
    z-index: 3;
  }
}

.mask {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);
}

.toAnswer {
  width: 100%;
  line-height: 33px;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  font-size: 24px;
  font-weight: 300;
  cursor: pointer;
  background-color: rgba(0, 0, 0, 0.5);

  .arrow {
    width: 23px;
    height: 18px;
    background: url("~images/full_screen_arrow@2x.png") no-repeat center / cover;
    margin-left: 10px;
  }
}

.full-screen-btn {
  width: 100px;
  z-index: 3;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: -100px;
  position: relative;

  .submit-oj-btn {
    color: #fff;
    background: #f8d458;
    margin-bottom: 15px;

    &:disabled {
      background: #d0d0d0 !important;
      color: #999 !important;
      cursor: not-allowed !important;
      opacity: 0.6;
    }
  }
  button {
    flex-shrink: 0;
    position: relative;
    width: 60px;
    height: 60px;
    border-radius: 50%;
    box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.15);
    cursor: pointer;
    transition: all 0.3s ease-in-out;
    padding: 8px 14px;
    font-size: 14px;
    line-height: 20px;
    margin-bottom: 15px;

    &:hover {
      font-size: 16px;
      padding: 8px 12px;
    }

    &:disabled {
      &:hover {
        font-size: 14px;
      }

      &::after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba($color: #fff, $alpha: 0.5) url(~@/assets/images/detect/mb-outer-loading.png) no-repeat 50% 50% / 50% auto;
        border-radius: 50%;
        cursor: default;
        animation: loadingCircle 1s infinite linear;
      }
    }
  }

  .btn {
    color: #fff;
    // background: #397EFD;
  }

  .open-btn {
    background: #fff;
    color: $themeColor;
    border: 1px solid $themeColor;
    padding: 8px 14px;
  }

  .question-detail {
    position: absolute;
    right: 100px;
    top: 57px;
    bottom: 40px;
    width: 0;
    height: calc(100% - 100px);
    background-color: #fff;
    box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.1);
    text-align: left;
    transition: width ease 0.3s;

    &.show {
      width: 612px;
      padding: 20px 20px 80px 20px;

      .icon-close {
        display: inline-block;
        z-index: 1;
        position: relative;
      }
    }

    .icon-close {
      display: none;
      width: 16px;
      height: 16px;
      background: url("~@/assets/images/icon-black-close.png") center / cover no-repeat;
      float: right;
      cursor: pointer;
    }

    .content {
      margin-top: 40px;
      font-size: 18px;
      color: $titleColor;
      line-height: 27px;
      overflow: scroll;
      height: 100%;

      /deep/ img {
        max-width: 100%;
      }
    }
  }

  .reset-ques {
    font-size: 14px;
    color: #397efd;
    margin-top: 40px;
    background-color: #fff;
  }
}

.new-type-wrap {
  .upload-wrap {
    width: 100%;
    padding: 30px 0 30px 13px;
    color: #111;
    font-size: 16px;
    background-color: #fafafa;

    .tip {
      margin-bottom: 20px;
    }

    .answer-wrap {
      padding: 5px 0 0 75px;
      height: 55px;
      position: relative;
      display: flex;

      .python-icon {
        position: absolute;
        top: 0;
        left: 0;
        width: 55px;
        height: 55px;
        background: url("~images/python-icon.png") center / cover no-repeat;
      }

      .answer-info {
        width: 256px;
        color: #333;
        font-size: 16px;
        line-height: 25px;

        .file-name {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .upload-time {
          color: #999;
          font-size: 14px;
        }
      }

      .change-btn {
        line-height: 25px;
        font-size: 16px;
        color: #377dfd;
        cursor: pointer;
        margin-left: 20px;
      }
    }
  }

  .data-upload,
  .data-download {
    display: flex;
    align-items: center;
    height: 42px;
    padding: 0 30px;
    border: 1px solid #397efd;
    border-radius: 4px;
    color: #397efd;
    font-size: 16px;
    line-height: 22px;
    cursor: pointer;
    background-color: #fff;

    .download-icon,
    .upload-icon {
      display: inline-block;
      width: 19px;
      height: 18px;
      background: url("~images/nct-download.png") no-repeat center / cover;
      margin-right: 9px;
    }

    .upload-icon {
      background: url("~images/nct-upload.png") no-repeat center / cover;
    }
  }

  .data-download {
    margin: 0 0 25px 13px;
  }
}

.option-wrap {
  display: inline-block;

  .option {
    display: flex;
    border-radius: 8px;
    border: 1px solid #efefef;
    margin-bottom: 20px;
    cursor: pointer;
    overflow: hidden;
    padding-right: 15px;
    min-width: 480px;
    max-width: 70%;

    .option-name-wrap {
      flex: 0 0 35px;
      background-color: #f5f9ff;
      margin-right: 15px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .option-content {
      display: flex;
      flex-direction: column;
      padding: 18px 0;

      .desc {
        width: 100%;
      }

      .image {
        max-width: 100%;
        display: block;
        border-radius: 4px;
      }
    }

    &:hover {
      border: 1px solid $themeColor;

      .option-name-wrap {
        border-right: 1px solid $themeColor;
      }
    }

    &.is-select {
      border: 1px solid $themeColor;

      .option-name-wrap {
        background-color: $themeColor;
        color: #fff;
      }
    }
  }
}

.white-btn {
  @include cancel-btn(96px, 36px, 14px, 4px);
  margin-right: 20px;
  margin-bottom: 10px;
}

.blue-btn {
  @include theme-fill-btn(96px, 36px, 14px, 4px);
}

.countdown {
  position: fixed;
  top: 8px;
  right: 120px;
  z-index: 3;
  color: #ac6f29;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(172, 111, 41, 0.25);
  border-radius: 45px;
  width: 242px;
  height: 36px;

  .word {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(172, 111, 41, 1);
  }

  .time {
    font-size: 24px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: rgba(172, 111, 41, 1);
    margin-left: 8px;
  }
}

.py-countdown {
  top: 6px;
  height: 28px;
}

.scratch-countdown {
  top: 6px;
  background: rgba(0, 62, 175, 0.25);

  .word {
    color: rgba(255, 255, 255, 1);
  }

  .time {
    color: rgba(255, 255, 255, 1);
  }
}

.tart-countdown,
.box3d-countdown {
  background: rgba(0, 0, 0, 0.25);

  .word {
    color: #fff;
  }

  .time {
    color: #fff;
  }
}

.full-screen-position {
  right: 50%;
  transform: translateX(50%);
  &.box3d-countdown {
    right: 500px;
  }
}

.fadeInRight {
  animation-name: fadeInRight;
  animation-duration: 0.5s;
}

@keyframes fadeInRight {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(100%, 0, 0);
    transform: translate3d(100%, 0, 0);
  }

  to {
    opacity: 1;
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
  }
}

.fadeOutRight {
  animation-name: fadeOutRight;
  animation-duration: 0.5s;
}

@keyframes fadeOutRight {
  0% {
    opacity: 1;
  }

  to {
    opacity: 0;
    -webkit-transform: translate3d(100%, 0, 0);
    transform: translate3d(100%, 0, 0);
  }
}

.loading {
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99;
  background: rgba(0, 0, 0, 0.4);
}

.box-full-screen {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9;
}

.box-full-screen-content {
  height: calc(100% - 40px) !important;
}

.box-full-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  i {
    display: inline-block;
    width: 16px;
    height: 16px;
    background-size: contain;
  }

  .close {
    background-image: url(../../../assets/images/icon_close-full.png);
  }

  .full {
    background-image: url(../../../assets/images/icon_full.png);
  }

  span {
    font-size: 14px;
    font-weight: 400;
    color: #999999;
    line-height: 20px;
    margin-left: 7px;
  }

  &:hover {
    span {
      color: #387efd;
    }

    .close {
      background-image: url(../../../assets/images/icon_close-full_b.png);
    }

    .full {
      background-image: url(../../../assets/images/icon_full_b.png);
    }
  }
}
.explore-question-wrap {
  align-items: center;
  justify-content: center;
  height: 100%;
}
.operate-question-wrap {
  display: flex;
  .operate-question-load-tips {
    width: 400px;
    height: 180px;
    background: #FEF8EE;
    border-radius: 4px;
    padding: 25px;
    margin-left: 20px;
    color: #333;
    font-size: 16px;
    line-height: 22px;
    .operate-question-load-tips-btn {
      color: #387efd;
      cursor: pointer;
      text-decoration: underline;
      &:hover {
        color: #1b64ec;
      }
      &:active {
        color: #093fa4;
      }
    }
    .operate-question-load-tips-title {
      font-size: 17px;
      font-weight: 500;
      color: #333;
      margin-bottom: 10px;
    }
    .operate-question-load-tips-content {
      font-size: 14px;
      font-weight: 400;
      color: #333;
      line-height: 30px;
    }
  }
}
</style>
